module.exports = __webpack_public_path__ + "images/emoji/lock_with_ink_pen.7e6242aa0f9531d55cd4.png";